import React, { Component } from 'react';
import { CardBody } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import Button from '@material-ui/core/Button';


class ProceduresTwo extends Component {
    constructor(props) {
        super(props);

        this.state = {
            results: '',            
        }
    }

    componentDidMount() {

    }

    handlerResults = (results) => {
        this.setState({ results: results });
    }

    render() {

        return (            
                <CardBody>
                    <div className="form" style={{ flex: 1, flexDirection: 'column' }}>
                        <div className="card__title">
                            <h5 className="bold-text">Procedimiento Laboratorio</h5>
                        </div>
                        <div className="form__form-group">
                            <span className="form__form-group-label">Resultados:</span>
                            <div className="form__form-group-field">
                                <Field
                                    name="textarea-impresion-"
                                    component="textarea"
                                    type="text"
                                    onChange={(e) => {
                                        this.handlerResults(e.target.value)
                                    }}
                                />
                            </div>
                        </div>
                        <div className="form__form-group">
                            <Button
                                style={{ marginTop: 20 }}
                                variant="contained"
                                color="primary"
                            >
                                Guardar Procedimiento
                            </Button>
                        </div>
                    </div>
                </CardBody>);
    }
}

export default reduxForm({
    form: 'procedurestwo_form', // a unique identifier for this form
})(ProceduresTwo);